import { PageFilterFactoryRef } from './page-filter.function';
import { PageFilterItem } from '../types/page-filter-item';
import { PageFilterLink } from '../types/page-filter-link';

export interface PageFilterLinkOptions<T extends object, TValue> {
  origin: PageFilterItem<T, TValue>;
  targets: PageFilterItem<any, TValue>[];
}

export function pageFilterLink<T extends object, TValue>(ref: PageFilterFactoryRef, options: PageFilterLinkOptions<T, TValue>): PageFilterLink<T,  TValue> {
  const link = {origin: options.origin, targets: options.targets};
  ref.addLink(link)
  return link;
}
